export interface Environment {
  production: boolean;
  apiUrl: string;
  assetUrl: string;
}

export const environment: Environment = {
  production: false,
  // apiUrl: 'https://rda7-dev.itehk-services.com/api',
  // assetUrl: 'https://rda7-dev.itehk-services.com/storage'
    apiUrl: 'https://rda-dev.itehk-services.com/api',
  assetUrl: 'https://rda-dev.itehk-services.com/storage'
};
